import * as React from 'react';
import cn from 'classnames';
import { getProgressLevel } from '@features/price-graph';
import { useTheme } from '../../../../../../theme';
import { Money as MoneyComponent } from '../../../../../../Money';
const Legends = ({ minPrice, maxPrice, children }) => {
    const { LegendsStyles: css } = useTheme('Features').PriceGraph;
    const contentElRef = React.useRef(null);
    const legendsWrapperRef = React.useRef(null);
    const roRef = React.useRef(null);
    const setContentEl = React.useCallback((node) => {
        contentElRef.current = node;
    }, []);
    React.useLayoutEffect(() => {
        const contentEl = contentElRef.current;
        const legendsEl = legendsWrapperRef.current;
        if (!contentEl || !legendsEl) {
            return undefined;
        }
        const applyHeight = () => {
            legendsEl.style.height = `${contentEl.getBoundingClientRect().height}px`;
        };
        if (typeof ResizeObserver !== 'undefined') {
            roRef.current = new ResizeObserver(entries => {
                var _a;
                const entry = entries[0];
                if (((_a = entry === null || entry === void 0 ? void 0 : entry.contentRect) === null || _a === void 0 ? void 0 : _a.height) !== null) {
                    legendsEl.style.height = `${entry.contentRect.height}px`;
                }
            });
            roRef.current.observe(contentEl);
        }
        else {
            applyHeight();
        }
        return () => {
            var _a;
            (_a = roRef.current) === null || _a === void 0 ? void 0 : _a.disconnect();
        };
    }, []);
    const renderLine = (price, level, className, specialText) => (React.createElement("div", { className: cn(css.line, className), style: { bottom: `${level}%` } },
        React.createElement("div", { className: css.label },
            specialText && React.createElement("span", { className: css.label__text }, specialText),
            React.createElement(MoneyComponent, { moneyClassName: css.money, money: { amount: price.amount, currency: price.currency } }))));
    const averagePrice = { amount: Math.round(maxPrice.amount / 2), currency: maxPrice.currency };
    const averageLineIsVisible = (averagePrice.amount - minPrice.amount) / averagePrice.amount > 0.4;
    const maxLineIsVisible = (maxPrice.amount - minPrice.amount) / maxPrice.amount > 0.2;
    const isMinAndMaxPricesEqual = minPrice.amount === maxPrice.amount;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: css.legends, ref: legendsWrapperRef },
            (maxLineIsVisible || isMinAndMaxPricesEqual) && renderLine(maxPrice, 100, css.line_max),
            averageLineIsVisible && renderLine(averagePrice, 50),
            !isMinAndMaxPricesEqual && renderLine(minPrice, getProgressLevel(minPrice.amount, maxPrice.amount))),
        children(setContentEl)));
};
export default Legends;
